import { button, el } from './dom.js';

export interface TopbarHandle {
  readonly element: HTMLElement;
  setLevel(level: number): void;
  setMoves(used: number, budget: number): void;
  onMute(handler: (next: boolean) => void): void;
  onReset(handler: () => void): void;
  onHelp(handler: () => void): void;
  setMuted(m: boolean): void;
}

export const buildTopbar = (): TopbarHandle => {
  const lvlEl = el('span', { text: 'L1' });
  const movEl = el('span', { text: '0/0' });

  let muteHandler: (m: boolean) => void = () => {};
  let resetHandler: () => void = () => {};
  let helpHandler: () => void = () => {};
  let muted = false;

  const muteBtn = button('🔊', 'icon-btn', () => {
    muted = !muted;
    muteBtn.textContent = muted ? '🔇' : '🔊';
    muteHandler(muted);
  }, { 'aria-label': 'Sound' });
  const resetBtn = button('↻', 'icon-btn', () => resetHandler(), { 'aria-label': 'New' });
  const helpBtn = button('?', 'icon-btn', () => helpHandler(), { 'aria-label': 'Help' });

  const root = el('header', {
    className: 'topbar',
    children: [
      el('div', {
        className: 'title',
        children: [el('span', { className: 'title-mark' }), el('span', { text: 'CBLIX2' })],
      }),
      el('div', { className: 'stats', children: [lvlEl, movEl] }),
      el('div', { className: 'actions', children: [resetBtn, helpBtn, muteBtn] }),
    ],
  });

  return {
    element: root,
    setLevel: (level) => (lvlEl.textContent = `L${level}`),
    setMoves: (used, budget) => (movEl.textContent = `${used}/${budget}`),
    onMute: (h) => (muteHandler = h),
    onReset: (h) => (resetHandler = h),
    onHelp: (h) => (helpHandler = h),
    setMuted: (m) => {
      muted = m;
      muteBtn.textContent = m ? '🔇' : '🔊';
    },
  };
};
